import { render, staticRenderFns } from "./Record2List.vue?vue&type=template&id=2a9ffb3a&scoped=true&"
import script from "./Record2List.vue?vue&type=script&lang=ts&"
export * from "./Record2List.vue?vue&type=script&lang=ts&"
import style0 from "./Record2List.vue?vue&type=style&index=0&id=2a9ffb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ffb3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
